export default __webpack_public_path__ + "static/media/print_estimate_shanai_4.b7ff0ac7.svg";